import httpUtils from '../../utils/HttpUtils'

class ActivityCustomerEnrollService {

  async list() {
    let result = null;
    try {
      result = await httpUtils.post('/activity/customer/enroll/list')
    } catch (error) {
      console.log('连接失败', error);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }
}
export default new ActivityCustomerEnrollService()
